import React from 'react';
import { Wrapper, Container } from './style';
import { Toast } from 'antd-mobile';
import { get } from '../../utils/request';
import Config from '../../config';
import icon_zfb from '../../assets/images/icon_zfb.png';

class Account3 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      bankInfo: {}
    }
  }
  async componentDidMount() {
    document.title = '提现账户'
    this.loadInfo()
  }
  async loadInfo(){
    let params = {}
    let res = await get(`/pgy/user/${Config.appId}/home`, params)
    res = res.data.data
    this.setState({bankInfo: res.bankInfo})
  }
  goInfo(){
    this.props.history.push(`/account2`)
  }
  render() {
    let { bankInfo } = this.state;
    return (
      <Wrapper>
        <Container>
          {bankInfo.paymentType==1&&(
            <div className="card">
              <span>{bankInfo.bankName}</span>
              <p>{bankInfo.accountNo}</p>
            </div>
          )}
          {bankInfo.paymentType==2&&(
            <div className="card card2">
              <img src={icon_zfb} />
              <p>{bankInfo.accountNo}</p>
            </div>
          )}
          <div className="btns">
            <div className="btn" onClick={() => this.goInfo()}>修改</div>
          </div>
        </Container>
      </Wrapper>
    );
  }
}
export default Account3;